import { clearLocalStorage, getLocalStorage } from "../userStore";
import { useNavigate } from "react-router-dom";
import { logout, getLoggedinUser } from "../userStore";
import DropDown from "../components/DropDown";
import moment from "moment";
import { useEffect, useState } from "react";
import { getUserPictureUrl } from "../utils/common_lib";
import defaultProfileImg from "../assests/images/default_profile_img.png";

export const AppHeader = (props) => {
  const [imgSrc, setImgSrc] = useState(defaultProfileImg);
  const isLoggedIn = getLocalStorage("isLoggedIn");
  const user = getLoggedinUser();
  useEffect(() => {
    if (user?.pid) {
      const picUrl = getUserPictureUrl(user.pid, "patient", 100, 100);
      const img = new Image();
      img.onload = () => setImgSrc(picUrl);
      img.onerror = () => setImgSrc(defaultProfileImg);
      img.src = picUrl;
    }
  }, [user]);

  const [time, setTime] = useState(moment());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(moment());
    }, 1000);

    return () => clearInterval(intervalId); // cleanup on unmount
  }, []);

  return (
    <>
      {/* <button type="button" className="-m-2.5 p-2.5 text-gray-700 lg:hidden">
        <span className="sr-only">Open sidebar</span>
        <svg
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          aria-hidden="true">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          />
        </svg>
      </button> */}

      <div className="h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true"></div>

      <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <div className="flex items-center gap-x-4 lg:gap-x-6 ms-auto">
          <p className="text-white hidden md:block">
            {time.format("MM/DD/YYYY hh:mm A")}
          </p>
          <div
            className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10"
            aria-hidden="true"></div>

          {isLoggedIn ? (
            <>
              <DropDown
                icon={
                  <img
                    src={imgSrc}
                    className="h-8 w-8 rounded-full bg-gray-50"
                    alt="user_picture"
                  />
                }
                title={user?.full_name}
                customStyle=" items-center text-white bg-transparent shadow-inherit"
                menuList={[
                  {
                    label: "Logout",
                    onClick: () => {
                      logout();
                    },
                  },
                ]}
              />
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};
